<section class="progress-reports">
  <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ statusMessage }}</div>
  <header class="d-print-none">
    <h1 class="styled-heading h3 primary-text">Progress Reports</h1>
  </header>
  <form id="progress-report-form" class="control-bar styled-form d-print-none">
    <div class="control-bar-group control-bar-left">

      <!-- Report Control -->
      <div class="form-label-input-combo">
        <!--suppress XmlInvalidId -->
        <label for="report-input" class="form-label">
          Report
        </label>
        <zbp-select
          labelForId="report-input"
          bindLabel="type"
          bindValue="queryParam"
          [clearable]="true"
          [items]="reportTypes"
          [formControl]="reportControl"
          [zbpNgSelectSrValue]="reportControl"
          clearAllText="Clear Report"
          [placeholder]="defaultDropDownText"
          (valueChange)="resetReports()"
          />
      </div>

      <!-- Class Control -->
      <div class="form-label-input-combo">
        <!--suppress XmlInvalidId -->
        <label for="class-input" class="form-label">
          Class
          @if (isLoadingClassrooms) {
            <img class="form-field-spinner" src="/assets/img/Spin-1s-100px.svg" alt="loading classrooms">
          }
        </label>
        <zbp-select
          labelForId="class-input"
          bindLabel="name"
          bindValue="classroomId"
          [clearable]="true"
          [items]="classrooms"
          [formControl]="classroomIdControl"
          [zbpNgSelectSrValue]="classroomIdControl"
          clearAllText="Clear Class"
          [placeholder]="defaultDropDownText"
          />
      </div>

      @if (showGradeDropdown) {
        <!-- Grade Control -->
        <div class="form-label-input-combo">
          <!--suppress XmlInvalidId -->
          <label for="grade-input" class="form-label">
            Grade
            @if (isLoadingProducts) {
              <img class="form-field-spinner" src="/assets/img/Spin-1s-100px.svg" alt="loading products"/>
            }
          </label>
          <zbp-select
            labelForId="grade-input"
            bindLabel="variantDescription"
            bindValue="skuId"
            [clearable]="true"
            [items]="products"
            [matchOptionWidth]="true"
            [formControl]="productSkuIdControl"
            [zbpNgSelectSrValue]="productSkuIdControl"
            clearAllText="Clear Grade"
            [placeholder]="defaultDropDownText"
            />
        </div>
      } @else {
        <!-- Product Control -->
        <div class="form-label-input-combo">
          <!--suppress XmlInvalidId -->
          <label for="product-input" class="form-label">
            Product
            @if (isLoadingProducts) {
              <img class="form-field-spinner" src="/assets/img/Spin-1s-100px.svg" alt="loading products"/>
            }
          </label>
          <zbp-select
            labelForId="product-input"
            bindLabel="description"
            bindValue="skuId"
            [clearable]="true"
            [items]="products"
            [formControl]="productSkuIdControl"
            [zbpNgSelectSrValue]="productSkuIdControl"
            clearAllText="Clear Product"
            [placeholder]="defaultDropDownText"
            />
        </div>
      }

      @if(showSkillDropdown) {
        <!-- Skill Control -->
        <div class="form-label-input-combo">
          <!--suppress XmlInvalidId -->
          <label for="skill-input" class="form-label">
            Skill
            @if (isLoadingSkills) {
              <img class="form-field-spinner" src="/assets/img/Spin-1s-100px.svg" alt="loading skills">
            }
          </label>
          <zbp-select
            labelForId="skill-input"
            [formControl]="skillControl"
            bindLabel="objective"
            bindValue="objective"
            [items]="skills$ | async"
            placeholder="Make Selection"
            [clearable]="true"
            [matchOptionWidth]="false"
            customClass="use-minimum-width" />
        </div>
      }

      <!-- Placeholder for dynamic form controls.  -->

      <div class="control-bar-group control-bar-inner-group">

        <!-- Add the LAST(or last couple of) controls in the innergroup so the Apply button is always w/ that group
        This group will not wrap to prevent the 'submit' button dangling on a row by itself -->
        <!-- Student Control -->
        @if (showStudentDropdown) {
          <div class="form-label-input-combo">
            <!--suppress XmlInvalidId -->
            <label for="student-input" class="form-label">
              Student
              @if (isLoadingStudent) {
                <img class="form-field-spinner" src="/assets/img/Spin-1s-100px.svg" alt="loading students"/>
              }
            </label>
            <zbp-select
              labelForId="student-input"
              bindLabel="displayName"
              bindValue="userId"
              [clearable]="true"
              [items]="students"
              [formControl]="studentIdControl"
              [zbpNgSelectSrValue]="studentIdControl"
              clearAllText="Clear Student"
              placeholder="Select Student"
              />
          </div>
        }

        @if (showActivityDropdown) {
          <div class="form-label-input-combo">
            <!--suppress XmlInvalidId -->
            <label for="activity-input" class="form-label">
              Activity
              @if (isLoadingActivity) {
                <img class="form-field-spinner" src="/assets/img/Spin-1s-100px.svg" alt="loading activities"/>
              }
            </label>
            <zbp-select
              labelForId="activity-input"
              bindLabel="topicName"
              bindValue="topicKey"
              [clearable]="true"
              [items]="topicsList$ | async"
              [formControl]="activityIdControl"
              [zbpNgSelectSrValue]="activityIdControl"
              clearAllText="Clear Activity"
              placeholder="Select Activity"
              />
          </div>
        }

        @if (showViewGroupDropdown) {
          <div class="form-label-input-combo">
            <!--suppress XmlInvalidId -->
            <label for="view-group-input"
              class="form-label">
              View
            </label>
            <zbp-select
              labelForId="view-group-input"
              bindValue="value"
              bindLabel="label"
              [clearable]="true"
              [isReadonly]="viewGroupOptions.length == 1"
              [items]="viewGroupOptions"
              [formControl]="viewGroupControl"
              [zbpNgSelectSrValue]="viewGroupControl"
              clearAllText="Clear View"
              (clear)="clearViewGroupControl()"
              [ngbTooltip]="(!!selectedClassroom && viewGroupOptions.length == 1)
                                ? 'Add student groups to use views on this report'
                                : undefined"
              />
          </div>
        }

        <zbp-button-component
          class="apply-button"
          label="Apply"
          theme="primary"
          [disabled]="selectionForm.invalid"
          [showSpinner]="isLoadingReport"
          (clickHandler)="onApplyButtonClick()"
          />
      </div>
    </div>

    <div class="control-bar-right">
      @if (showObjectiveFilter) {
        <div class="form-label-input-combo">
          <!--suppress XmlInvalidId -->
          <label for="objective-filter-input"
            class="form-label">
            Filter
          </label>
          <zbp-select
            labelForId="objective-filter-input"
            bindValue="value"
            bindLabel="label"
            [clearable]="true"
            [isReadonly]="objectiveFilterOptions.length == 1"
            [items]="objectiveFilterOptions"
            [formControl]="objectiveFilterControl"
            [zbpNgSelectSrValue]="objectiveFilterControl"
            (clear)="clearObjectiveFilterControl()"
            (valueChange)="applyFilter()"
            [ngbTooltip]="(showObjectiveFilter && !objectiveFilterInitialized)
              ? 'Generate a report to enable filter options'
              : (showObjectiveFilter && objectiveFilterInitialized && objectiveFilterOptions.length === 1)
              ? 'These tests are self-contained and do not have multiple parts'
              : undefined"
            />
        </div>
      }
    </div>

  </form>

  @if (reportControl.value === ProgressReportQueryParamByType.ClassOverTime && classOverTimeReportData) {
    <!-- Class Over Time Report -->
    <zbp-branded-class-over-time-report-detail
      [showProgressReportsHelp]="true"
      [classOverTimeReport]="classOverTimeReportData"
      [isPrinting]="classOverTimeConfig.isPrinting"
      [printableReportHeadings]="printableReportHeadings"
      />
  } @else if (reportControl.value === ProgressReportQueryParamByType.IndividualStudentOverTime && individualStudentOverTimeReportData) {
    <!-- Individual Student Over Time Report -->
    <zbp-branded-individual-student-over-time-report-detail
      [studentOverTimeReport]="individualStudentOverTimeReportData"
      [productType]="selectedProduct?.productType"
      [productName]="selectedProduct?.description"
      [variant]="selectedProduct?.variant"
      [classroomId]="classroomIdControl.value"
      [className]="selectedClassroom?.name"
      [studentId]="studentIdControl.value"
      [isPrinting]="individualStudentOverTimeConfig.isPrinting"
      [printableReportHeadings]="printableReportHeadings"
      (refreshData)="onRefresh()"
      [role]="role"
      />
  } @else if (reportControl.value === ProgressReportQueryParamByType.ClassSpread && classSpreadReportData) {
    <!-- Class Spread Report -->
    <zbp-branded-class-spread-report-detail
      [classSpreadReport]="classSpreadReportData"
      [className]="selectedClassroom?.name"
      [productName]="selectedProduct?.description"
      [variant]="selectedProduct?.variant"
      [isPrinting]="classSpreadTimeConfig.isPrinting"
      [printableReportHeadings]="printableReportHeadings"
      [role]="role"
      (refreshData)="onRefresh()"
      />
  } @else if (reportControl.value === ProgressReportQueryParamByType.StandardsDetail && classStandardsDetailReportData) {
    <!-- Class Standards Detail Report -->
    <zbp-shared-standards-detail-report
      [reports]="classStandardsDetailReportData"
      [isLoading]="isLoadingReport"
      [noDataMessage]="statusMessage"
      (pageChange)="standardsDetailPageChange($event)"
      />
  } @else if (reportControl.value === ProgressReportQueryParamByType.StandardsOverTime && standardsOverTimeReportData) {
    <!-- Class Standards Over Time Report -->
    <zbp-standards-over-time-report-detail
      [standardsOverTimeReport]="standardsOverTimeReportData"
      [isPrinting]="standardsOverTimeConfig.isPrinting"
      [printableReportHeadings]="printableReportHeadings"
      />
  } @else if (reportControl.value === ProgressReportQueryParamByType.SkillAverages && skillAveragesReportData) {
    <!-- Class Skills Average Report -->
    @if (skillAveragesReportData.benchmarkResults.length > 0) {
      <zbp-admin-skills-average-detail
        [benchmarkSkillsAverageReport]="skillAveragesReportData"
        [page]="page"
        (pageChange)="skillPageChange($event)"
        [pageSize]="pageSize"
        [maxPageCount]="maxPageCount"
        [collectionSize]="collectionSize"
        [isPrinting]="skillAveragesConfig.isPrinting"
        [printableReportHeadings]="printableReportHeadings"
        />
    } @else {
      <!-- If no results then show no scores table -->
      <zbp-branded-report-no-selection
        [noDataMessage]="'No scores available'"
        [showProgressReportsHelp]="false"
        />
    }
  } @else if (reportControl.value === ProgressReportQueryParamByType.ClassSkillsHeatmap && classSkillsHeatmapReportData) {
    <!-- Class Skills Heatmap Report -->
    <zbp-branded-class-skills-heatmap-report-detail
      [classSkillsHeatmapReport]="classSkillsHeatmapReportData"
      [className]="selectedClassroom?.name"
      [productName]="selectedProduct?.description"
      [variant]="selectedProduct?.variant"
      (refreshData)="onRefresh()"
      [isPrinting]="classSkillsHeatmapConfig.isPrinting"
      [printableReportHeadings]="printableReportHeadings"
      [role]="role"
      />
  } @else {
    <!-- If no report type is selected (somehow) or the data for selected report is not loaded -->
    <zbp-branded-report-no-selection [showProgressReportsHelp]="!!reportTypesWithOnPageHelp[reportControl.value]"/>
  }

  <!-- Print button will show if there is current report data from any type of report  -->
  <nav class="export-print d-print-none">
    <div class="export-print-buttons">
      @if (enableExport) {
        <zbp-button-component
          label="Export Scores"
          iconName="export"
          [disabled]="!enableExport"
          [showSpinner]="isExporting"
          (clickHandler)="export()"
          />
      }
      @if (enablePrint) {
        <zbp-button-component
          label="Print Scores"
          [iconName]="iconNames.printer"
          [showSpinner]="isPrinting"
          (clickHandler)="print()"
          />
      }
      @if (showPrintAllScoreDetails) {
        <zbp-button-component
          label="Print All Score Details"
          [disabled]="!enablePrintAllScoreDetails"
          (clickHandler)="printAllScoreDetails()"
          [tooltip]="!enablePrintAllScoreDetails ? disabledPrintAllScoreDetailsTooltip : ''"
          />
      }
    </div>
    <zbp-branded-fallback-download
      #exportDownload
      class="d-block ms-auto text-end"
      />
  </nav>
</section>



